module.exports = __webpack_public_path__ + "static/media/VisualMerchandise-Flyer.fb487129.pdf";